var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16666 7.50033C4.16666 4.27533 6.77499 1.66699 9.99999 1.66699C13.225 1.66699 15.8333 4.27533 15.8333 7.50033C15.8333 11.8753 9.99999 18.3337 9.99999 18.3337C9.99999 18.3337 4.16666 11.8753 4.16666 7.50033ZM7.91666 7.50033C7.91666 8.65033 8.84999 9.58366 9.99999 9.58366C11.15 9.58366 12.0833 8.65033 12.0833 7.50033C12.0833 6.35033 11.15 5.41699 9.99999 5.41699C8.84999 5.41699 7.91666 6.35033 7.91666 7.50033Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7588502d54f3a216b952524c242de1dd.svg";
export { ForwardRef as ReactComponent };